<template>
  <div class="pagination-table desktop-shadow-card rounded">
    <nav
      v-if="showTopPagination"
      aria-label="Page navigation"
      class="py-3 d-flex justify-content-sm-between justify-content-center align-items-center mx-4"
    >
      <div class="d-none d-sm-block">
        {{ labelToDisplay(from, to, this.count) }}
      </div>
      <ul class="pagination p-0 m-0">
        <li
          class="page-item"
          :class="[currentPage <= 1 ? 'disabled' : '']"
          v-if="showFirstButton"
        >
          <a
            :disabled="currentPage == 1"
            class="page-link"
            href="#"
            @click.prevent="onPageChange(1)"
          >
            <i class="fa fa-angle-double-left px-2"></i>
          </a>
        </li>
        <li class="page-item" :class="[currentPage <= 1 ? 'disabled' : '']">
          <a
            :disabled="currentPage <= 1"
            class="page-link"
            href="#"
            @click.prevent="onPageChange(currentPage - 1)"
          >
            <i class="fa fa-angle-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          v-for="page in range(startPage, endPage)"
          :key="page"
          :class="[currentPage == page ? 'active' : '']"
        >
          <a class="page-link" href="#" @click.prevent="onPageChange(page)">{{
            page
          }}</a>
        </li>
        <li
          class="page-item"
          :class="[currentPage >= lastPage ? 'disabled' : '']"
        >
          <a
            class="page-link"
            href="#"
            @click.prevent="onPageChange(currentPage + 1)"
          >
            <i class="fa fa-angle-right"></i>
          </a>
        </li>
        <li
          v-if="showLastButton"
          class="page-item"
          :class="[currentPage == lastPage ? 'disabled' : '']"
        >
          <a class="page-link" href="#" @click.prevent="onPageChange(lastPage)">
            <i class="fa fa-angle-double-right px-2"></i>
          </a>
        </li>
      </ul>
    </nav>
    <div class="table-body">
      <slot></slot>
    </div>
    <nav
      aria-label="Page navigation"
      class="pb-3 d-flex justify-content-sm-between justify-content-center align-items-center mx-4"
    >
      <div class="d-none d-sm-block">
        {{ labelToDisplay(from, to, this.count) }}
      </div>
      <ul class="pagination p-0 m-0">
        <li
          class="page-item"
          :class="[currentPage <= 1 ? 'disabled' : '']"
          v-if="showFirstButton"
        >
          <a
            :disabled="currentPage == 1"
            class="page-link"
            href="#"
            @click.prevent="onPageChange(1)"
          >
            <i class="fa fa-angle-double-left px-2"></i>
          </a>
        </li>
        <li class="page-item" :class="[currentPage <= 1 ? 'disabled' : '']">
          <a
            :disabled="currentPage <= 1"
            class="page-link"
            href="#"
            @click.prevent="onPageChange(currentPage - 1)"
          >
            <i class="fa fa-angle-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          v-for="page in range(startPage, endPage)"
          :key="page"
          :class="[currentPage == page ? 'active' : '']"
        >
          <a class="page-link" href="#" @click.prevent="onPageChange(page)">{{
            page
          }}</a>
        </li>
        <li
          class="page-item"
          :class="[currentPage >= lastPage ? 'disabled' : '']"
        >
          <a
            class="page-link"
            href="#"
            @click.prevent="onPageChange(currentPage + 1)"
          >
            <i class="fa fa-angle-right"></i>
          </a>
        </li>
        <li
          v-if="showLastButton"
          class="page-item"
          :class="[currentPage == lastPage ? 'disabled' : '']"
        >
          <a class="page-link" href="#" @click.prevent="onPageChange(lastPage)">
            <i class="fa fa-angle-double-right px-2"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  emits: {
    onPageChange: {
      required: true,
    },
  },
  props: {
    showTopPagination: {
      type: Boolean,
      default: false,
    },
    showFirstButton: {
      type: Boolean,
      default: false,
    },
    showLastButton: {
      type: Boolean,
      default: false,
    },
    labelDisplayedRows: {
      type: Function,
      default: (from, to, count) => `Showing ${from} to ${to} of ${count}`,
    },
    count: { type: Number, required: true },
    currentPage: { type: Number, required: true },
    rowsPerPage: { type: Number, required: true },
  },
  watch: {
    count: function () {
      this.setPaginationPages(this.currentPage);
    },
  },
  data() {
    return {
      startPage: 1,
      endPage: 1,
    };
  },
  mounted() {
    this.setPaginationPages(this.currentPage);
  },
  computed: {
    from: function () {
      return this.rowsPerPage * (this.currentPage - 1) + 1;
    },
    to: function () {
      return this.from + this.rowsPerPage > this.count
        ? this.count
        : this.from + this.rowsPerPage - 1;
    },
    lastPage: function () {
      return Math.ceil(this.count / this.rowsPerPage);
    },
    range: function () {
      return (min, max) => {
        var array = [],
          j = 0;
        for (var i = min; i <= max; i++) {
          array[j] = i;
          j++;
        }
        return array;
      };
    },
  },
  methods: {
    onPageChange: function (page) {
      if (page == this.currentPage) {
        return;
      }
      this.setPaginationPages(page);
      this.$emit("onPageChange", page);
    },
    labelToDisplay: function () {
      return this.labelDisplayedRows(this.from, this.to, this.count);
    },
    setPaginationPages: function (page) {
      this.startPage = Math.max(1, page - 3);
      this.endPage = Math.min(page + 3, this.lastPage);
    },
  },
};
</script>
<style scoped lang="scss">
.pagination-table {
  background-color: white;
  .navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pagination {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
